export default __webpack_public_path__ + "static/media/06_sla.14fd5b87.png";